module.exports = __webpack_public_path__ + "static/media/pfSense_step3.0e50205a.png";